export const API_BASEURL = "http://neurosphere.cos.northeastern.edu/api/";

export const T_TRANSFORMATION_DISABLED = 101;

export const PARAM_CONFIG = [
  {
    type: "number",
    title: "Pa",
    name: "PA",
    desc: "Probability of stem cell activation",
    min: "0.1",
    max: "1",
    step: "0.01",
  },
  {
    type: "number",
    title: "Quiescence Time",
    name: "N_quiescent",
    desc:
      "Number of time steps after mitosis during which a quiescent stem cell cannot be activated",
    min: "1",
    max: "10",
    step: "1",
  },
  {
    type: "number",
    title: "Proliferative Potential",
    name: "N_proliferative",
    desc: "Number of divisions after which a progenitor cell differentiates",
    min: "1",
    max: "12",
    step: "1",
  },
  {
    type: "number",
    title: "Clearance Time",
    name: "N_death",
    desc:
      "Number of time steps after which a dead cell is cleared from its lattice site",
    min: "1",
    max: "12",
    step: "1",
  },
  {
    type: "number",
    title: "Min Pm",
    name: "PM_min",
    desc: "Minimum probability of mitosis",
    min: "0",
    max: "1",
    step: "0.01",
  },
  {
    type: "number",
    title: "Max Pm",
    name: "PM_max",
    desc: "Maximum probability of mitosis",
    min: "0",
    max: "1",
    step: "0.01",
  },
  {
    type: "number",
    title: "Min Pd",
    name: "PD_min",
    desc: "Minimum probability of daughter cell death",
    min: "0",
    max: "1",
    step: "0.01",
  },
  {
    type: "number",
    title: "Max Pd",
    name: "PD_max",
    desc: "Maximum probability of daughter cell death",
    min: "0",
    max: "1",
    step: "0.01",
  },
  {
    type: "number",
    title: "Time Steps Until Transformation",
    name: "t_transformation",
    desc:
      "Number of time steps after which one randomly selected progenitor cell is transformed into a BTSC",
    min: "2",
    max: "20",
    step: "1",
  },
];
